import { Tabs as UITabs, TabsContent } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { List } from "@radix-ui/react-tabs";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { clientOnboardingSchema, clientOnboardingType } from "./validator";
import { Form } from "@/components/ui/form";
import {
  Step1Content,
  Step1ContentPreview,
  Step2Content,
  Step2ContentPreview,
} from "./components";
import { ChevronLeft } from "lucide-react";
import LogoIcon from "@/components/icons/LogoIcon";
import useCurrentUserStore from "@/store";
import { Navigate } from "react-router-dom";

const OnBoarding: React.FC = () => {
  const [step, setStep] = useState(1);
  const { dashboardAccessToken } = useCurrentUserStore();
  const form = useForm<clientOnboardingType>({
    resolver: zodResolver(clientOnboardingSchema),
    defaultValues: {
      step1: {
        email: "",
      },
      step2: {
        otp: "",
      },
    },
  });

  const onSubmit = () => {};

  const handleNext = () => {
    if (dashboardAccessToken && dashboardAccessToken.length > 1) {
      <Navigate to={"/app-creation"} />;
    } else {
      setStep(step + 1);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <main className="flex flex-col-reverse lg:flex-row lg:p-2 max-w-[99vw] lg:h-screen">
          <div className="flex flex-col gap-4 lg:w-[40%]">
            {/* Logo */}
            <LogoIcon />

            {/* Tab List */}
            <div className="flex flex-col">
              <UITabs value={step.toString()}>
                <List
                  className={cn("flex items-center gap-2", {
                    hidden: [1, 2, 3].includes(step),
                  })}
                >
                  <ChevronLeft
                    className={cn("mr-2 cursor-pointer", {
                      "opacity-0": step === 1,
                    })}
                    onClick={() => setStep(step - 1)}
                  />
                </List>

                <TabsContent
                  value="1"
                  className="p-2 md:px-2 focus-visible:ring-0 max-w-[98vw]"
                >
                  <Step1Content form={form} nextTrigger={handleNext} />
                </TabsContent>
                <TabsContent value="2" className="px-4 focus-visible:ring-0">
                  <Step2Content
                    form={form}
                    backTrigger={() => setStep(1)}
                    nextTrigger={handleNext}
                  />
                </TabsContent>
              </UITabs>
            </div>
          </div>

          {/* preview */}
          <div className="lg:w-[60%]">
            {step === 1 && <Step1ContentPreview />}
            {step === 2 && <Step2ContentPreview />}
          </div>
        </main>
      </form>
    </Form>
  );
};

export default OnBoarding;
